import { toast } from 'react-toastify';
import { LectureWithScheduleMetadata } from '../../../../../../../api/types/programs/course/lectures/lecture-with-schedule-metadata';
import appApi from '../../../../../../../api/app-api';
import { AxiosError } from 'axios';
import { getDisplayTextForErrorCode } from '../../../../../../../api/types/errors/api-error-code';
import globalCourseStore from '../../../../../../../stores/global-course-store';
import globalLectureBuilderStore from '../../../../../../../stores/global-lecture-builder-store';
import { ApiErrorCodes } from '../../../../../../../api/errors/api-error-codes';
import { UserAttendanceRequest } from '../../../../../../../api/types/lecturers/attendance/user-attendance-request';

export const completeLectureOperation = async (
  programId: number | undefined,
  lecture: LectureWithScheduleMetadata | null,
  sessions: {
    sessionAttendanceId: number;
    attendance: UserAttendanceRequest[];
  }[],
  startTime: Date,
  endTime: Date,
  breakMinutes: number | null,
) => {
  try {
    if (!lecture) {
      toast.warn('לא ניתן לבצע את הפעולה המבוקש, נסה שוב בעוד מספר רגעים');
      return;
    }

    if (isNaN(Number(programId))) {
      toast.warn(
        'לא ניתן לאתר את מזהה הקורס ו/או התוכנית כעת, נסה שוב בעוד מספר רגעים',
      );
      return;
    }
    if (sessions.length === 0) {
      toast.warn('יש לסמן נוכחות עבור מפגש אחד לפחות');
      return;
    }

    const res = await appApi.completeLecture(
      programId!,
      lecture.item.courseId,
      lecture.item.id,
      sessions,
      startTime,
      endTime,
      breakMinutes,
    );

    if (
      res.data.errCode === ApiErrorCodes.COMPLETE_LECTURE_INVALID_TIME_RANGE
    ) {
      toast.warn('לא ניתן לסגור הרצאה בטווח של יותר מחמש שעות מהכתנון המקורי');

      return;
    }

    // Update the course lectures state
    globalCourseStore.fetchCourseDetails(programId!, lecture.item.courseId);

    // Update the state so the dialog of the lecture will be close
    globalLectureBuilderStore.selectedLecture = null;

    toast.success('הפעולה בוצעה בהצלחה');
  } catch (e) {
    if (e instanceof AxiosError && e?.response?.data.errCode !== undefined) {
      toast.warn(getDisplayTextForErrorCode(e.response.data.errCode));
      return;
    }
    console.error();
    toast.error('לא ניתן לבצע את הפעולה המבוקשת');
  }
};
